





























import PTextField from '../p-text-field/p-text-field.vue';
import interactable from '../../mixins/interactable/interactable';
import colorable from '../../mixins/colorable/colorable';
import clearable from '../../mixins/clearable/clearable';
import mixins from '../../mixins';

export default mixins(interactable, colorable, clearable).extend({
  props: {
    ...((new PTextField()).$options.props),
    value: { type: String, default: undefined },
    // Label is not imported from text-field for some reason
    label: { type: String, default: '' },
  },
  data: () => ({
    time: undefined as string | undefined,
    date: undefined as string | undefined,
  }),
  watch: {
    value: {
      immediate: true,
      handler(newValue: string) {
        if (newValue) {
          const combined = this.$date(newValue);
          this.date = combined.format('YYYY-MM-DD');
          this.time = combined.format('HH:mm:ss');
        } else {
          this.date = undefined;
          this.time = undefined;
        }
      },
    },
  },
  methods: {
    onClearClick() {
      const combined = this.combineDateTime(this.date, this.time);
      this.$emit('input', combined);
    },
    onInputTime() {
      const combined = this.combineDateTime(this.date, this.time);
      this.$emit('input', combined);
    },
    onInputDate() {
      const combined = this.combineDateTime(this.date, this.time);
      this.$emit('input', combined);
    },
    combineDateTime(date?: string, time?: string) {
      if (date && !time) {
        return this.$date(date).format();
      } if (date && time) {
        return this.$date(`${date}T${time}`).format();
      }
      return undefined;
    },
  },
});
